module.exports = __webpack_public_path__ + "img/logo_new.275a0e7.png";